module.exports = __webpack_public_path__ + "static/media/NETHERLANDS.ebcd669e.svg";